export default "__VITE_ASSET__e3264d61__"